import LocalStorageUtils from '@/utils/localStorageUtils'
import GrammarUtils from '@/utils/grammarUtils'
import FrenchDepartments from '@/data/frenchDepartments'
import BootsrapperUtils from '@/utils/bootstrapperUtils'

export default
{
    get isProductionEnv ()
    {
        return process.env.NODE_ENV == 'production'
    },

    get envCityId ()
    {
        if (this.isProductionEnv && cordova.platformId == 'browser')
        {
            console.log('Production browser detected, taking city id from location')

            const loc = window.location.pathname.split('/')

            //          loc[0] loc[1]    loc[2]  
            //            |     |         |
            // {hostname} / {pathname} / # / {component route}
            if (loc.length < 3)
            {
                console.log(`Current location ${window.location} is not formatted to extract city name`)

                if (LocalStorageUtils.cityManifest && LocalStorageUtils.cityManifest.alias)
                {
                    const alias = LocalStorageUtils.cityManifest.alias
                    console.log('Using already fetched city manifest alias', alias, 'as envCityId')

                    return alias
                }
                else
                {
                    throw new Error('No city manifest already fetched to redirect to last visited city site')
                }
            }
    
            return loc[1]
        }
        else if (BootsrapperUtils.originalEnvCityId)
        {
            console.log('App has been bootstrapped, taking former city id', BootsrapperUtils.originalEnvCityId)
            
            return BootsrapperUtils.originalEnvCityId
        }
        else
        {
            console.log('Taking city id from build bundle identifier')

            return __APP_ID__
        }
    },

    get cityName ()
    {
        return LocalStorageUtils.cityManifest.name
    },
    get cityId ()
    {
        return LocalStorageUtils.cityManifest.id
    },
    get clientName ()
    {
        return LocalStorageUtils.cityManifest.clientName
    },

    /**
     * @typedef {Object} CityFeatures
     * @property {boolean} hasReports
     * @property {boolean} hasStores
     * @property {boolean} hasLoyaltyCard
     * @property {boolean} hasLostObjects
     * @property {boolean} hasLostPets
     * @property {number} storeNotificationsMonthlyLimit
     * @property {string} appVersion
     */
    /**
     * @returns {CityFeatures}
     */
    get cityFeatures ()
    {
        return LocalStorageUtils.cityManifest.cityFeatures
    },
    get cityZipcode ()
    {
        return LocalStorageUtils.cityManifest.location.replace(/ /gm, '').match(/[0-9]{5}/)[0]
    },
    get cityDepartment ()
    {
        return FrenchDepartments.find(d => d.departmentCode == this.cityZipcode.substr(0, 2)).departmentName
    },
    get cityDepartmentWithPronoun ()
    {
        var dep = this.cityDepartment   

        if (GrammarUtils.isVowel(dep[0])) dep = 'l\'' + dep

        return dep
    }
}


// WEBPACK FOOTER //
// ./src/utils/environmentUtils.js